export const getButtonText = (isInProgress: boolean) => {
  const text = isInProgress ? "Reanudar examen" : "Rendir examen";
  return text;
};

export const getClassButton = (
  isMinorTablet: boolean,
  isScheduled: boolean
) => {
  return `mt-10 focus:bg-primary-60 ${isMinorTablet ? "w-full" : ""} ${
    isScheduled ? "hidden" : ""
  } `;
};
